import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import parcelServices from '@/parcels/services/services'

const useExportParcels = ({ getFilters, setToastInfo, storeId }) => {
  const { t } = useTranslation()
  const [showExportModal, setShowExportModal] = useState(false)
  const { fetchData: exportResults, loading: exportingResults } = useFetch(parcelServices.exportResults, {
    doInitialRequest: false,
  })

  const openExportModal = () => {
    setShowExportModal(true)
  }

  const closeExportModal = () => {
    setShowExportModal(false)
  }

  const onExportResults = async ({ format, email }) => {
    const filters = getFilters()

    try {
      await exportResults({ format, email, filters, storeId })
      setShowExportModal(false)
      setToastInfo({
        show: true,
        message: t(
          'Tu exportación se entregará por email a {{email}}. Esto podría tardar unos instantes dependiendo de cuantos envíos estés exportando.',
          { email }
        ),
        type: 'success',
        ms: 5000,
      })
    } catch (err) {
      setToastInfo({ show: true, message: err.errorMessage, type: 'error' })
    }
  }

  return {
    showExportModal,
    openExportModal,
    closeExportModal,
    exportResults,
    exportingResults,
    onExportResults,
  }
}

export default useExportParcels
